import * as moment from 'moment';
import { useMemo } from 'react';
import { Button, Modal, Panel, PanelGroup } from 'react-bootstrap';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import { IMentorCompletionsList } from '@nkr/models/mentor-completions-list';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, IHeaderParams, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';

interface IProps {
    show: boolean,
    data: IMentorCompletionsList,
    userName: string,
    onClose: () => void
}

const Details = (props: IProps) => {
    if (props.data == null)
        return null;

    const firstContactAttemptColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const firstContactAttemptColumnDefs = useMemo(() => firstContactAttemptColumns, []);

    const firstContactMadeColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const firstContactMadeColumnDefs = useMemo(() => firstContactMadeColumns, []);

    const workupSurveyColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const workupSurveyColumnDefs = useMemo(() => workupSurveyColumns, []);

    const preopSurveyColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const preopSurveyColumnDefs = useMemo(() => preopSurveyColumns, []);

    const atSurgerySurveyColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const atSurgerySurveyColumnDefs = useMemo(() => atSurgerySurveyColumns, []);

    const postSurgerySurveyColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },

        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const postSurgerySurveyColumnDefs = useMemo(() => postSurgerySurveyColumns, []);

    const donationColumns: ColDef[] = [
        {
            colId: 'rowNumber',
            headerName: 'R#',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
        },
        
        {
            headerName: 'First Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
            field: 'firstName',
            width: 150
        },

        {
            headerName: 'Last Name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
            field: 'lastName',
            width: 150,
            sort: 'asc'
        },

        {
            headerName: 'Email',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email</SortableHeaderComponent>,
            field: 'email',
            width: 250
        },

        {
            headerName: 'Phone Number',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Phone Number</SortableHeaderComponent>,
            field: 'phoneNumber',
            width: 150
        },

        {
            headerName: 'Completion Date',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Completion Date</SortableHeaderComponent>,
            field: 'completionDate',
            width: 150,
            cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY') }
        }
    ];

    const donationColumnDefs = useMemo(() => donationColumns, []);

    return (
        <Modal show={props.show} bsSize='large' backdrop='static' onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Mentor: {props.userName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PanelGroup>
                    <Panel>
                        <Panel.Heading>First Contact Attempts (<b>{props.data.firstContactAttempts.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={firstContactAttemptColumnDefs}
                                rowData={props.data.firstContactAttempts}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                suppressContextMenu={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.firstContactAttempts.length == 0 && (
                                            <>No records found...</>
                                        )}
                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>First Contacts Made (<b>{props.data.firstContactsMade.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={firstContactMadeColumnDefs}
                                rowData={props.data.firstContactsMade}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.firstContactsMade.length == 0 && (
                                            <>No records found...</>
                                        )}

                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>Workup Surveys (<b>{props.data.workupSurveys.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={workupSurveyColumnDefs}
                                rowData={props.data.workupSurveys}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.workupSurveys.length == 0 && (
                                            <>No records found...</>
                                        )}

                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>Pre-Op Surveys (<b>{props.data.preOpSurveys.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={preopSurveyColumnDefs}
                                rowData={props.data.preOpSurveys}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.preOpSurveys.length == 0 && (
                                            <>No records found...</>
                                        )}

                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>At-Surgery Surveys (<b>{props.data.atSurgerySurveys.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={atSurgerySurveyColumnDefs}
                                rowData={props.data.atSurgerySurveys}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.atSurgerySurveys.length == 0 && (
                                            <>No records found...</>
                                        )}
                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>Post-Surgery Surveys (<b>{props.data.postSurgerySurveys.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={postSurgerySurveyColumnDefs}
                                rowData={props.data.postSurgerySurveys}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.postSurgerySurveys.length == 0 && (
                                            <>No records found...</>
                                        )}

                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>

                    <Panel>
                        <Panel.Heading>Donations (<b>{props.data.donationsMade.length}</b>)</Panel.Heading>
                        <GridWrapper className='ag-theme-bootstrap'>
                            <AgGridReact
                                columnDefs={donationColumnDefs}
                                rowData={props.data.donationsMade}
                                // rowHeight={25}
                                suppressCellSelection={true}
                                rowSelection='single'
                                noRowsOverlayComponentFramework={params =>
                                    <>
                                        {props.data.donationsMade.length == 0 && (
                                            <>No records found...</>
                                        )}

                                    </>
                                }
                                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            />
                        </GridWrapper>
                    </Panel>
                </PanelGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Details;